module.exports = __webpack_public_path__ + "static/booth-bg-39b71b4129cb46efd1e948c8d546d7d1.jpg";